var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6.4H2.688A2.496 2.496 0 00.2 2.889v14.933A2.496 2.496 0 002.69 20.31h19.91a2.496 2.496 0 002.49-2.488V2.889A2.496 2.496 0 0022.598.4zm0 17.422h-2.49V6.87L12.645 11.6 5.178 6.87v10.952H2.689V2.889h1.493l8.462 5.226 8.462-5.226H22.6v14.933z",
    fill: "url(#gmail_svg__paint0_linear_6101_35786)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6.4H2.688A2.496 2.496 0 00.2 2.889v14.933A2.496 2.496 0 002.69 20.31h19.91a2.496 2.496 0 002.49-2.488V2.889A2.496 2.496 0 0022.598.4zm0 17.422h-2.49V6.87L12.645 11.6 5.178 6.87v10.952H2.689V2.889h1.493l8.462 5.226 8.462-5.226H22.6v14.933z",
    fill: "url(#gmail_svg__paint1_linear_6101_35786)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gmail_svg__paint0_linear_6101_35786",
    x1: 25.585,
    y1: 0.583,
    x2: 5.956,
    y2: 25.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gmail_svg__paint1_linear_6101_35786",
    x1: 3.933,
    y1: 17.199,
    x2: 21.463,
    y2: -1.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F75C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D22B24"
  })))));
}

export default __webpack_public_path__ + "./fonts/gmail.4a41db89e68aefa5bb9a3afa28aec882.svg";
export { SvgGmail as ReactComponent };